export const CONTROL_FREQUENCIES = [
  { value: 1, viewValue: 'manual_call_form_frequency_1_day' },
  { value: 2, viewValue: 'manual_call_form_frequency_2_days' },
  { value: 3, viewValue: 'manual_call_form_frequency_3_days' },
  { value: 4, viewValue: 'manual_call_form_frequency_4_days' },
];
